module.exports = __webpack_public_path__ + "static/img/item02.c233916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item02.png
// module id = k6+k
// module chunks = 0